import { render } from "./FontsSheet.vue?vue&type=template&id=2ec9a140&ts=true"
import script from "./FontsSheet.vue?vue&type=script&lang=ts"
export * from "./FontsSheet.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__